import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen w-full flex flex-col items-center justify-center px-4 py-20 overflow-hidden bg-bg-primary" data-id="element-111">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-radial-top pointer-events-none" data-id="element-112" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(0,255,136,0.05)_0%,_transparent_50%)] pointer-events-none" data-id="element-113" />

      {/* Content Container */}
      <div className="relative z-10 max-w-6xl mx-auto text-center" data-id="element-114">
        {/* Ebook Image with Glow */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-12" data-id="element-115">
          <div className="relative inline-block" data-id="element-116">
            <div className="absolute inset-0 animate-hero-glow rounded-2xl" data-id="element-117" />
            <img src="https://cdn.magicpatterns.com/uploads/fMjjuNvA9y6j4GiJz7cGRR/heylloyd-image-1772303912052.png" alt="The Anonymous Asset System - iPad and Book Stack" className="relative w-full max-w-md md:max-w-lg lg:max-w-xl mx-auto rounded-2xl" data-id="element-118" />
          </div>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6" data-id="element-119">
          The Anonymous Asset System
          <br data-id="element-120" />
          <span className="text-2xl md:text-4xl lg:text-5xl font-bold" data-id="element-121">
            Build Your Faceless YouTube Empire with AI
          </span>
        </motion.h1>

        {/* Subheadline */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-lg md:text-xl lg:text-2xl text-text-muted max-w-4xl mx-auto mb-10 leading-relaxed" data-id="element-122">
          How to Generate Predictable Monthly Income from YouTube Without Ever
          Showing Your Face, Buying a Camera, or Being a "Personality."
        </motion.h2>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-123">
          <a href="#offer-cta" className="inline-block bg-accent-green text-bg-primary font-bold text-lg md:text-xl uppercase tracking-wide px-8 md:px-12 py-4 md:py-5 rounded-lg animate-pulse-glow hover:scale-105 transition-transform duration-300" data-id="element-124">
            Get The Anonymous Asset System Now
          </a>
          <p className="text-text-muted text-sm mt-4" data-id="element-125">Instant PDF Download</p>
        </motion.div>

        {/* Scroll Indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1.2
      }} className="absolute bottom-8 left-1/2 -translate-x-1/2" data-id="element-126">
          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} data-id="element-127">
            <ArrowDownIcon className="w-6 h-6 text-text-muted" data-id="element-128" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}